interface BoxInBoxTileProps {
  title?: string;
  description?: string;
  href?: string;
  imageSrc?: string;
  imageAlt?: string;
  linkLabel?: string;
  fieldBindings?: Partial<Record<"title" | "description" | "href" | "imageSrc" | "imageAlt" | "linkLabel", string>>;
}

export const BoxInBoxTile = ({
  title = "Matrix Drops",
  description = "Support your body with a restorative wellness treatment.",
  href = "/massage-services",
  imageSrc = "/uploads/matrix_drops.png",
  imageAlt = "Matrix Drops wellness product",
  linkLabel = "Learn more",
  fieldBindings,
}: BoxInBoxTileProps) => (
  <a
    href={href}
    data-tina-field={fieldBindings?.href}
    className="group relative mb-7 flex min-h-[290px] w-full max-w-[320px] flex-col items-center justify-end overflow-visible rounded-3xl bg-gradient-to-b from-[#7a00da] via-[#6200af] to-[#33005b] px-5 pb-5 pt-8 shadow-[0_18px_40px_rgba(51,0,91,0.2)] transition duration-300 hover:-translate-y-2 hover:shadow-[0_24px_48px_rgba(51,0,91,0.3)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/40 dark:shadow-[0_18px_40px_rgba(0,0,0,0.3)]"
  >
    <div
      className="flex h-44 w-full shrink-0 items-center justify-center rounded-2xl bg-white/10 p-4 ring-1 ring-inset ring-white/20"
      data-tina-field={fieldBindings?.imageAlt}
    >
      <img
        src={imageSrc}
        alt={imageAlt}
        data-tina-field={fieldBindings?.imageSrc}
        className="max-h-full max-w-full object-contain drop-shadow-[0_12px_14px_rgba(0,0,0,0.25)] transition duration-300 group-hover:scale-105"
      />
    </div>
    <div className="relative z-10 -mb-12 mt-4 flex h-52 w-full shrink-0 flex-col overflow-hidden rounded-2xl bg-[#f4edf9] p-4 text-left shadow-[0_8px_24px_rgba(171,190,209,0.35)] transition duration-300 group-hover:shadow-[0_12px_28px_rgba(171,190,209,0.45)] dark:bg-[#2b1742] dark:shadow-[0_8px_24px_rgba(0,0,0,0.28)]">
      <h3
        className="text-center shrink-0 font-poppins font-semibold text-[#33005b] dark:text-violet-100"
        data-tina-field={fieldBindings?.title}
      >
        {title}
      </h3>
      <p
        className="mt-1 text-sm leading-5 text-center text-slate-600 dark:text-violet-200"
        data-tina-field={fieldBindings?.description}
      >
        {description}
      </p>
      <div className="mt-auto shrink-0 pt-3 text-center">
        <span
          className="inline-flex items-center justify-center rounded-full bg-primary px-4 py-2 text-center text-sm font-semibold leading-none text-white transition-colors group-hover:bg-primary-darker dark:group-hover:bg-primary/80"
          data-tina-field={fieldBindings?.linkLabel}
        >
          {linkLabel}
        </span>
      </div>
    </div>
  </a>
);
export default BoxInBoxTile;
